import React from "react";

export default function Alert() {
  return (
    <svg
      width="18"
      height="15"
      viewBox="0 0 18 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5586 12.3086L9.99609 0.90625C9.50391 0.0585938 8.21875 0.03125 7.72656 0.90625L1.16406 12.3086C0.671875 13.1562 1.30078 14.25 2.3125 14.25H15.4102C16.4219 14.25 17.0508 13.1836 16.5586 12.3086ZM8.875 9.92969C9.55859 9.92969 10.1328 10.5039 10.1328 11.1875C10.1328 11.8984 9.55859 12.4453 8.875 12.4453C8.16406 12.4453 7.61719 11.8984 7.61719 11.1875C7.61719 10.5039 8.16406 9.92969 8.875 9.92969ZM7.67188 5.41797C7.64453 5.22656 7.80859 5.0625 8 5.0625H9.72266C9.91406 5.0625 10.0781 5.22656 10.0508 5.41797L9.85938 9.13672C9.83203 9.32812 9.69531 9.4375 9.53125 9.4375H8.19141C8.02734 9.4375 7.89062 9.32812 7.86328 9.13672L7.67188 5.41797Z"
        fill="currentColor"
      />
    </svg>
  );
}
